/**
 * useCollectionQueries — react-query 기반 컬렉션 데이터 훅.
 *
 * 알림과 같은 정책(staleTime 30초 + 포커스 재조회). 컬렉션은 본인만 바꾸는 데이터라
 * 폴링할 이유가 없고, 등록·수정·삭제 뒤 COLLECTION_KEY 를 무효화하면 충분하다.
 *
 * 비로그인은 아예 호출하지 않는다 — §6.1 상 저장 자체가 불가라 401 을 받을 뿐이다.
 */
import { useQuery } from "@tanstack/react-query";
import { fetchCollection, type CollectionResponse } from "../api/collection";
import { useAuthStore } from "../store/authStore";

export const COLLECTION_KEY = ["collection"] as const;

export function useCollectionQuery() {
  const isAuthed = useAuthStore((s) => !!s.accessToken);
  return useQuery<CollectionResponse>({
    queryKey: COLLECTION_KEY,
    queryFn: () => fetchCollection(),
    enabled: isAuthed,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
